import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "heatmaps" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "heatmaps_container",
      style: _normalizeStyle('opacity:' + _ctx.opacity)
    }, [
      _createElementVNode("div", {
        class: "wrapper",
        style: _normalizeStyle(_ctx.viewerStyle)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableHeatmaps, (heatmap) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "svgImage",
            key: heatmap.classification,
            style: _normalizeStyle(heatmap.style)
          }, null, 4)), [
            [_vShow, heatmap.isActive]
          ])
        }), 128))
      ], 4)
    ], 4)
  ], 512)), [
    [_vShow, _ctx.isHeatmapsVisible]
  ])
}